import React, { useState, useEffect } from 'react';
import { FileDrop } from 'react-file-drop';
import axios from 'axios'
import { Table } from 'react-bootstrap';
import { Alert, Form, Modal, Button } from 'react-bootstrap'
import JsZip from 'jszip';
import { saveAs } from 'file-saver';
import dummyPDF from '../dummy_pdf_pdf2Data.pdf'


const DragDropCsv = () => {

    const [myFile, setMyFile] = useState([])
    const [error, setError] = useState("")
    const [chooseFile, setChooseFile] = useState(false)
    const [collectedAdvices, setCollectedAdvices] = useState([])
    const [loading, setLoading] = useState(false)
    const [pdfRecievedString, setPdfRecievedString] = useState(false)
    const [secondApiResponseStatus, setSecondApiResponseStatus] = useState(false)
    const [secondApiResponseSuccessStatus, setSecondApiResponseSuccessStatus] = useState(false)
    const [finalPdfLink, setFinalPdfLink] = useState(false)
    const [finalPdfStatus, setFinalPdfStatus] = useState(false)
    const [invalidFileErrorStatus, setInvalidFileErrorStatus] = useState(false)
    const [invalidPdfErrorStatus, setInvalidPdfErrorStatus] = useState(false)
    const [hideExtractingPdfLoader, setHideExtractingPdfLoader] = useState(false)
    const [selectionType, setSelectionType] = useState("no")
    const [sampleId, setSampleId] = useState("")
    const [userAllInfo, setAllUserInfo] = useState("")
    const [pdfLinks, setPdfLinks] = useState([])
    const [cSVBase64s, setCSVBase64s] = useState([])
    const [reportTypeAndSmartReportIdInputsStatus, setReportTypeAndSmartReportIdInputsStatus] = useState(false)
    const [gettingCsvSRstatus, setGettingCsvSRstatus] = useState(false)
    const [showZipButton, setShowZipButton] = useState(false)
    const [hideGenerateReportsButton, setHideGenerateReportsButton] = useState(false)
    const [disclaimerProvider, setDisclaimerProvider] = useState("")
    const [dsridsArray, setDsridsArray] = useState([])

    const [testName, setTestName] = useState("")
    const [lowValue, setLowValue] = useState("")
    const [highValue, setHighValue] = useState("")
    const [unitValue, setUnitValue] = useState("")
    const [resultValue, setResultValue] = useState("")
    const [recordOfNewTests, setRecordOfNewTests] = useState([])
    const [missingDataStatus, setMissingDataStatus] = useState(false)
    const [labName, setLabName] = useState("thyrocare")

    // modal state and functions
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const styles = {
        border: '3px dashed grey',
        width: "100%",
        color: 'black',
        padding: 20,
        backgroundColor: "#e6f7ff"
    };

    let requiredAdvicesArray = []

    const csvJSON = (csv) => {

        var lines = csv.split("\n");
        console.log("lines", lines)
        var result = [];
        var headers = lines[0].replace(/\s/g, "").split(",");


        for (var i = 1; i < lines.length; i++) {

            var obj = {};
            var currentline = lines[i].replace(/\r/g, "").split(",");

            for (var j = 0; j < headers.length; j++) {
                let currentHeader = headers[j].toLowerCase()
                obj[currentHeader] = currentline[j];
            }

            result.push(obj);

        }

        //let json = JSON.stringify(result)
        console.log("obj in result", result)
        return result; //JSON
    }


    const generateSRFromCSV = () => {
        try {
            //let check = myFile[0].type === "application/vnd.ms-excel"

            console.log("myFile", myFile)
            let files = myFile
            const formData = new FormData();
            formData.append('files[]', files[0])
            const reader = new FileReader();
            reader.onload = function (e) {
                var contents = e.target.result;
                //console.log("the contents", contents)
                const finalJson = csvJSON(contents)
                requiredJsonFormat(finalJson)
            }
            reader.readAsText(files[0])

        } catch (error) {
            console.log("error in csv\n", error)
        }
    }

    let myArray = []

    const requiredJsonFormat = (data) => {

        console.log("my data", data)
        setReportTypeAndSmartReportIdInputsStatus(true)
        setGettingCsvSRstatus(true)

        let requiredInfo = ""
        let profileRecieved = ""
        let patientDetails = ""
        let patientTest = ""
        let patientTestRecord = ""
        let patientRecord = ""

        for (let i = 0; i < data.length; i++) {

            if (data[i].patientname === "" && data[i].profilename === "") {
                let previousProfiles = []
                let locateProfile = requiredInfo.results.filter(eachProfile => eachProfile.profilename === profileRecieved)
                let profileFounded = locateProfile[0]
                previousProfiles = profileFounded.investigation

                if (data[i].result === "" || data[i].result === "NA") {
                    // do nothing
                } else {
                    previousProfiles.push({
                        "test": data[i].test,
                        "low": data[i].low,
                        "high": data[i].high,
                        "result": data[i].result,
                        "unit": data[i].unit
                    })

                    let findProfile = requiredInfo.results.filter(each => each.profilename === profileRecieved)
                    findProfile[0].investigation = previousProfiles
                }
            }

            if (data[i].patientname === "" && data[i].profilename !== "") {
                profileRecieved = data[i].profilename

                patientTest = {
                    "test": data[i].test,
                    "low": data[i].low,
                    "high": data[i].high,
                    "result": data[i].result,
                    "unit": data[i].unit
                }

                if (data[i].result === "" || data[i].result === "NA") {
                    patientTestRecord = {
                        "profilename": data[i].profilename,
                        "investigation": []
                    }
                } else {
                    patientTestRecord = {
                        "profilename": data[i].profilename,
                        "investigation": [patientTest]
                    }
                }

                let previousResults = []
                previousResults = requiredInfo.results

                previousResults.push(patientTestRecord)
            }

            if (data[i].patientname) {
                console.log("patient name", data[i].patientname)

                profileRecieved = data[i].profilename

                patientDetails = {
                    "patientname": data[i].patientname,
                    "age": data[i].age,
                    "Gender": data[i].gender,
                    "date": data[i].date,
                    "sampleid": data[i].sampleid,
                    "packagename": data[i].packagename
                }

                patientTest = {
                    "test": data[i].test,
                    "low": data[i].low,
                    "high": data[i].high,
                    "result": data[i].result,
                    "unit": data[i].unit
                }

                if (data[i].result === "" || data[i].result === "NA") {
                    patientTestRecord = {
                        "profilename": data[i].profilename,
                        "investigation": []
                    }
                } else {
                    patientTestRecord = {
                        "profilename": data[i].profilename,
                        "investigation": [patientTest]
                    }
                }

                patientRecord = {
                    "patientname": data[i].patientname,
                    "age": data[i].age,
                    "date": data[i].date,
                    "Gender": data[i].gender,
                    "sampleid": data[i].sampleid,
                    "packagename": data[i].packagename,
                    "disclaimer": disclaimerProvider,
                    results: [
                        patientTestRecord
                    ]
                }

                requiredInfo = patientRecord
                console.log("current patient record", patientRecord)
                myArray.push(patientRecord)
            }
        }

        setAllUserInfo(myArray)
        jsonHandler()
    }

    let myCurrentValue = 0
    let csvGeneratedBase64 = []
    let collectDsrIds = []

    const jsonHandler = async () => {
        let copyOfBase64 = []
        console.log("my Array data\n", myArray)

        var config2 = {
            method: 'post',
            //url: 'https://q2j8fegpu4.execute-api.ap-south-1.amazonaws.com/test/proactiveforher',
            url: 'https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/proactiveforher',
            headers: {
                'Content-Type': 'application/json'
            },
            data: myArray[myCurrentValue]
            //data: dummyData
        };
        console.log("what im sending\n", myArray[myCurrentValue])

        try {
            setHideGenerateReportsButton(true)
            const axiosData = await axios(config2)
            console.log("inside axiosdata ===> \n\n", axiosData)
            console.log("base64", axiosData.data.base64Pdf)
            collectDsrIds.push(axiosData.data.dsrId)
            csvGeneratedBase64.push(axiosData.data.base64Pdf)
            copyOfBase64.push(axiosData.data.base64Pdf)
            console.log("copyOfBase64\n", copyOfBase64)
            setCSVBase64s(csvGeneratedBase64)
            setDsridsArray(collectDsrIds)

            if (myCurrentValue === myArray.length) {
                // stop further execution
                setGettingCsvSRstatus(false)
                setShowZipButton(true)

            } else {
                myCurrentValue = myCurrentValue + 1
                jsonHandler()
            }

        } catch (error) {
            console.log(error)
            setShowZipButton(true)
            setGettingCsvSRstatus(false)
        }

    }

    console.log("cSVBase64s: \n", cSVBase64s)
    console.log("dsridsArray\n", dsridsArray)


    // const csvHandler = (csv) => {

    //     let lines = csv.split("\n");
    //     let result = [];
    //     let headers = lines[0].replace(/\s/g, "").split(",")

    //     console.log("headers", headers)

    //     for (let i = 1; i < lines.length; i++) {

    //         let obj = {};

    //         let currentline = lines[i].replace(/\r/g, "").split(",");
    //         console.log("currentline", currentline)

    //         for (let j = 0; j < headers.length; j++) {
    //             obj[headers[j]] = currentline[j];
    //         }
    //         result.push(obj);
    //     }
    //     console.log("requiredAdvicesArray", requiredAdvicesArray, requiredAdvicesArray.length)
    //     setCollectedAdvices(requiredAdvicesArray)
    //     console.log("array data", result)
    //     return result; //JSON
    // }

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file); // turns into base64
        });
    };

    let uniqueNumber = Math.round(Date.now() + Math.random())

    const fileHandler = async () => {
        try {
            console.log("try block got checked!")
            console.log("my file", myFile)
            let files = myFile
            console.log("files\n", files[0])
            console.log("file type", files[0].type)

            const fileType = files[0].type
            if (fileType !== "application/pdf") {


                let checkExcel = fileType.indexOf("excel").toString();
                let checkCsv = fileType.indexOf("csv").toString();

                if (checkExcel !== "-1" || checkCsv !== "-1") {
                    generateSRFromCSV()
                } else {
                    setError("Invalid File!")
                }

                // here
                // generate from csv


                //setError("Invalid File!")
                //setInvalidFileErrorStatus(true)
            } else {
                setLoading(true)
                const base64Data = await getBase64(files[0])
                let theData = await base64Data.split("base64,")[1]
                //console.log("the base64 we have\n", theData)
                var jsonFormat;

                if (missingDataStatus) {
                    jsonFormat = {
                        "data": theData,
                        "pcos": selectionType,
                        "sampleID": sampleId,
                        "uniqueNumber": uniqueNumber,
                        "disclaimer": disclaimerProvider,
                        "labName": labName,
                        "generatedFor": "demo",
                        "newTests": recordOfNewTests
                    }
                } else {
                    jsonFormat = {
                        "data": theData,
                        "pcos": selectionType,
                        "sampleID": sampleId,
                        "uniqueNumber": uniqueNumber,
                        "disclaimer": disclaimerProvider,
                        "labName": labName,
                        "generatedFor": "demo",
                        "newTests": []
                    }
                }

                console.log("uniqueNumber 1st", uniqueNumber)

                if (sampleId === "") {
                    setError("Sample Id cannot be empty!")
                } else {
                    setError("")
                    var config = {
                        method: 'post',
                        url: 'https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/pdfscrap',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: jsonFormat
                    };

                    console.log("What im sending\n", jsonFormat)

                    const axiosData = await axios(config)
                    console.log("inside axiosdata ===> \n\n", axiosData)
                }
            }
        } catch (error) {
            console.log("catch block got checked!")

            if (error.response && !invalidFileErrorStatus) {
                if (error.response.status === 504) {
                    setPdfRecievedString(true)
                    secondEndpointHandler()
                }
            } else {
                console.log("my file error in else case\n", error)
                setError("File Error!")
                setLoading(false)
            }
        }
        setLoading(false)
    }

    console.log("loadingstatus", loading)

    var limits = 0

    const secondEndpointHandler = () => {
        console.log(`calling second api now!, total tries ${limits} / 6`)
        setSecondApiResponseStatus(true)
        console.log("loading status", loading)
        setTimeout(() => {
            try {
                var config = {
                    method: 'post',
                    url: 'https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/pdfextractresponse',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: { "uniqueNumber": uniqueNumber }
                };

                console.log("uniqueNumber 2nd", uniqueNumber)

                const axiosData = axios(config)
                    .then((result) => {
                        console.log("my result", result)
                        if (result.data.pdf_url === "" && limits < 6) {
                            limits += 1
                            secondEndpointHandler()
                        } else {
                            if (result.data.pdf_url === "") {
                                setInvalidPdfErrorStatus(true)
                                setHideExtractingPdfLoader(true)
                            } else {
                                setFinalPdfLink(result.data.pdf_url)
                                setFinalPdfStatus(true)
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                console.log("inside axiosdata ===> \n\n", axiosData)
                setSecondApiResponseSuccessStatus(true)
            } catch (err) {
                console.log(err.message)
            }
        }, 15000)
    }


    const downloadPDF = (myPdfDoc, emp_id, emp_name) => {
        console.log("the file getting downloaded")
        const linkSource = `data:application/pdf;base64,${myPdfDoc}`;
        const downloadLink = document.createElement("a");
        const fileName = `${emp_id}-${emp_name}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const downloadZip = () => {
        console.log("your array\n", pdfLinks)

        var zip = new JsZip();
        let allFiles = zip.folder('myfiles')

        for (let i = 0; i < cSVBase64s.length; i++) {
            allFiles.file(`${userAllInfo[i].sampleid + '-' + userAllInfo[i].patientname}.pdf`, cSVBase64s[i], { base64: true });
        }

        zip.generateAsync({ type: "blob" })
            .then(function (content) {
                // see FileSaver.js
                saveAs(content, "SmartReports.zip");
            });
    }

    const checkFileType = (uploadedFileType) => {
        console.log("uploadedFileType", uploadedFileType)
        // let checkExcel = uploadedFileType.indexOf("excel").toString();
        // let checkCsv = uploadedFileType.indexOf("csv").toString();

        // if (checkExcel !== "-1" || checkCsv !== "-1") {
        //     setReportTypeAndSmartReportIdInputsStatus(true)
        // } else {
        //     setReportTypeAndSmartReportIdInputsStatus(false)
        // }
    }

    // console.log("selection type: ", selectionType)
    // console.log("loading status: ", loading)
    // console.log("csvGeneratedBase64\n", csvGeneratedBase64)

    const handleMissingTests = () => {
        console.log("filling missing test!")
        handleShow()
    }

    const saveNewTestsHandler = (e) => {
        e.preventDefault()
        let myNewTest = {
            "test": testName,
            "low": lowValue,
            "high": highValue,
            "result": resultValue,
            "unit": unitValue,
        }
        setRecordOfNewTests([...recordOfNewTests, myNewTest])
    }

    const downloadSamplePdf = () => {
        const link = document.createElement('a');
        link.href = `https://niroggyan.s3.ap-south-1.amazonaws.com/excel_for_portals/dummy_pdf_pdf2Data.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // console.log("Tests Saved:\n", recordOfNewTests)

    return (
        <div>
            {error ?
                <Alert variant="danger">
                    {error}
                </Alert>
                : ""}

            {/* Modal Start*/}
            <div>
                <>
                    <Modal show={show} onHide={handleClose} backdrop={"static"} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {"Add tests"}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={saveNewTestsHandler}>
                                <div style={{ display: myFile.length !== 0 ? "" : "none" }}>{"PDF Recieved "}<i className="far fa-check-circle text-primary"></i>
                                </div>
                                <div style={{ display: myFile.length !== 0 ? "none" : "" }} className="mb-3">
                                    <label style={{ fontWeight: "550" }} className="mb-1">{"Upload PDF"}</label>
                                    <input
                                        className="form-control"
                                        id="fileupload"
                                        type="file"
                                        onChange={(e) => {
                                            setMyFile(e.target.files)
                                            checkFileType(e.target.files[0].type)
                                            setError("")
                                        }}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <label style={{ fontWeight: "550" }} className="mb-1">{"Test Name"}</label>
                                    <input
                                        required
                                        onChange={(e) => setTestName(e.target.value)}
                                        value={testName}
                                        className='form-control' placeholder='test' />
                                </div>
                                <label style={{ fontWeight: "550" }} className="mb-1">{"Ref Ranges"}</label>
                                <div
                                    style={{ display: "inline-flex", justifyContent: "space-between", width: "100%" }}
                                >
                                    <input
                                        onChange={(e) => setLowValue(e.target.value)}
                                        value={lowValue}
                                        style={{ width: "48%" }} className='form-control' placeholder='low' />
                                    <input
                                        onChange={(e) => setHighValue(e.target.value)}
                                        value={highValue}
                                        style={{ width: "48%" }} className='form-control' placeholder='high' />
                                </div>

                                <label style={{ fontWeight: "550" }} className="my-3 mb-1">{"Unit & Result"}</label>
                                <div style={{ display: "inline-flex", justifyContent: "space-between", width: "100%" }}>
                                    <input
                                        onChange={(e) => setUnitValue(e.target.value)}
                                        value={unitValue}
                                        style={{ width: "48%" }} className='form-control' placeholder='unit' />
                                    <input
                                        onChange={(e) => setResultValue(e.target.value)}
                                        required
                                        value={resultValue}
                                        style={{ width: "48%" }} className='form-control' placeholder='result' />
                                </div>
                                <button type="submit" className="mt-3 btn btn-info btn-sm">{"Save & Create New"}</button>

                                <div className='mt-3' style={{ display: recordOfNewTests.length > 0 ? "" : "none" }}>
                                    <div>
                                        <span style={{ fontWeight: "550" }}>{"Tests Added"}</span>
                                        <span>{" ("}{recordOfNewTests.length}{")"}</span>
                                    </div>
                                    <div>
                                        {recordOfNewTests.map((each, idx) => <span key={idx}>
                                            {each.test}
                                            <span style={{ display: recordOfNewTests.length > 1 ? "" : "none" }}>{", "}</span>
                                        </span>
                                        )}
                                    </div>
                                </div>

                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary btn-sm" onClick={() => {
                                setMissingDataStatus(true)
                                handleClose()
                            }}>
                                {"Done"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            </div>

            {/* Modal End */}

            <div style={styles}>
                <FileDrop
                    onFrameDragEnter={(event) => console.log('onFrameDragEnter', event)}
                    onFrameDragLeave={(event) => console.log('onFrameDragLeave', event)}
                    onFrameDrop={(event) => console.log('onFrameDrop', event)}
                    onDragOver={(event) => console.log('onDragOver', event)}
                    onDragLeave={(event) => console.log('onDragLeave', event)}
                    onDrop={(files, event) => {
                        console.log('onDrop!', files, event)
                        setMyFile(files)
                        checkFileType(files[0].type)
                        console.log("your file type: ", files[0].type)
                        setError("")
                    }}
                >
                    {myFile.length > 0 ?
                        <span>
                            <i className="fas fa-file-alt fa-3x text-primary mb-1"></i>
                            <div style={{ fontSize: "1.1rem" }}>
                                <b>File Recieved: </b> {myFile[0].name}
                            </div>
                        </span>
                        :
                        <div>
                            {/* <span><i className="fas fa-file-excel fa-3x mb-3 text-secondary"></i></span>
                            <span className='mx-3'>{"OR"}</span> */}
                            <span><i className="fas fa-file-pdf fa-3x mb-3 text-primary"></i></span>
                            <div style={{ fontSize: "1.1rem", fontWeight: "600" }}>{"Drag & Drop your PDF file here"}</div>
                        </div>
                    }
                </FileDrop>
            </div>

            {chooseFile ?
                <input
                    className="form-control mt-3"
                    id="fileupload"
                    type="file"
                    onChange={(e) => {
                        setMyFile(e.target.files)
                        checkFileType(e.target.files[0].type)
                        setError("")
                    }}
                />
                :
                null
            }


            <a
                className='mx-3 mt-3'
                target={"_blank"}
                style={{ textDecoration: "none", float: "right" }}
                download
                href="https://niroggyan.s3.ap-south-1.amazonaws.com/excel_for_portals/dummy_pdf_pdf2Data.pdf"
                alt="pdf-link"
            >
                Sample for testing
            </a>

            {/* <a
                className='mx-3 mt-3'
                // target={"_blank"}
                style={{ textDecoration: "none", float: "right" }}
                href={dummyPDF} download="PDF-To-SR-Dummy.pdf"
            >{"Sample for testing"}
            </a> */}

            {/* <span
                className='mt-3'
                onClick={handleMissingTests}
                style={{ color: "#3077fd", textDecoration: "none", float: "right", cursor: "pointer" }}
            >
                {"Fill missing tests"}
            </span> */}

            <div className="d-flex my-3">
                <button className="btn btn-info btn-sm button-focus-css" onClick={() => setChooseFile(!chooseFile)}>
                    {chooseFile ? "Cancel Upload" : "Choose File"}
                </button>


                <button
                    disabled={hideGenerateReportsButton || loading || secondApiResponseStatus || myFile.length === 0}
                    className="btn btn-success btn-sm mx-3 button-focus-css" onClick={() => {
                        fileHandler()
                    }}>Generate Reports</button>

            </div>

            <div className="my-3 row" hidden={reportTypeAndSmartReportIdInputsStatus}>

                {/* <Form.Group className="col">
                    <Form.Label>
                        <span style={{ fontWeight: "500" }}>Report Type</span>
                    </Form.Label>
                    <select
                        onChange={(e) => setSelectionType(e.target.value)}
                        className="form-select"
                        defaultValue={selectionType}
                    >
                        <option value="no">Full Body Report</option>
                        <option value="yes">PCOS</option>
                    </select>
                </Form.Group> */}

                <Form.Group className="col" controlId="srId">
                    <Form.Label>
                        <span style={{ fontWeight: "500" }}>Smart Report Id</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        defaultValue={sampleId}
                        placeholder="id"
                        onChange={(e) => setSampleId(e.target.value)}
                    />
                </Form.Group>

                {/* <Form.Group className="col">
                    <Form.Label>
                        <span style={{ fontWeight: "500" }}>Disclaimer provider</span>
                    </Form.Label>
                    <select
                        onChange={(e) => setDisclaimerProvider(e.target.value)}
                        className="form-select"
                        defaultValue={disclaimerProvider}
                    >
                        <option value="">None</option>
                        <option value="Metropolis Healthcare Limited">Metropolis Healthcare Limited</option>
                        <option value="Thyrocare Technologies Limited">Thyrocare Technologies Limited</option>
                        <option value="IGenetic Diagnostics Private Limited">IGenetic Diagnostics Private Limited</option>
                        <option value="Neuberg Diagnostics Private Limited">Neuberg Diagnostics Private Limited</option>
                    </select>
                </Form.Group> */}

                {/* <Form.Group className="col">
                    <Form.Label>
                        <span style={{ fontWeight: "500" }}>{"Lab Name"}</span>
                    </Form.Label>
                    <select
                        onChange={(e) => setLabName(e.target.value)}
                        className="form-select"
                        defaultValue={labName}
                    >
                        <option value="thyrocare">{"thyrocare"}</option>
                        <option value="thyrocare_mumbai">{"thyrocare_mumbai"}</option>
                        <option value="thyrocare_banglore">{"thyrocare_banglore"}</option>
                        <option value="igenetic">{"igenetic"}</option>
                    </select>
                </Form.Group> */}

            </div>

            <div>
                {pdfRecievedString ?
                    <span>
                        <i className="far fa-check-circle text-primary"></i> Extracted PDF Data
                    </span>
                    :

                    ""
                }
            </div>
            <div>
                {gettingCsvSRstatus ?
                    <span>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span> Fetching Smart Reports...</span>
                    </span>
                    :
                    ""
                }

            </div>
            <div>
                {!loading ?
                    ""
                    :
                    <span>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span> Analyzing Pdf</span>
                    </span>

                }
            </div>

            <div hidden={hideExtractingPdfLoader}>
                {secondApiResponseStatus && !finalPdfStatus
                    ?
                    <span>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span> Extracting PDF URL</span>
                    </span>
                    :
                    ""
                }
            </div>
            {hideExtractingPdfLoader ?
                <div>
                    <span className="text-danger" ><i class="far fa-times-circle"></i></span>
                    <span> PDF Error!</span>
                </div>
                : ""
            }
            <div>
                {secondApiResponseSuccessStatus && finalPdfStatus ?
                    <span>
                        <i className="far fa-check-circle text-primary"></i>
                        <span> PDF Generated!</span>
                    </span>
                    : ""}
            </div>
            <div className="my-3">
                {invalidPdfErrorStatus ?
                    <div>
                        <Alert variant="danger">
                            <span>There are some irregularities in the structure of the uploaded PDF. Please <a href="#" onClick={() => window.location.reload()}>try again</a> with a different PDF!</span>
                        </Alert>
                    </div>
                    :
                    ""
                }
                {finalPdfStatus && !invalidPdfErrorStatus ?
                    <a style={{ textDecoration: "none" }} href={finalPdfLink} target="_blank">View PDF <i class="fas fa-file-pdf"></i></a>
                    : ""
                }</div>


            {/* CSV Smart Reports UI Handling */}

            <div>
                {cSVBase64s.length === 0 || cSVBase64s === undefined ?
                    ""
                    :
                    <div>
                        <Table striped bordered className="text-center">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Sample Id</th>
                                    <th>Patient Name</th>
                                    <th>
                                        Download Link
                                        {showZipButton ?
                                            <span
                                                style={{ marginLeft: "8px" }}
                                                className="btn btn-outline-success btn-sm button-focus-css"
                                                onClick={downloadZip}>Zip all Reports <i class="far fa-file-archive"></i></span>
                                            : ""}
                                    </th>
                                    <th>Show in DSR</th>
                                </tr>
                            </thead>

                            {cSVBase64s.map((eachRecord, idx) => (
                                <tbody>
                                    <tr key={idx + 1}>
                                        <td>{idx + 1}</td>
                                        <td>{userAllInfo[idx].sampleid}</td>
                                        <td>{userAllInfo[idx].patientname}</td>
                                        <td>
                                            <span
                                                className="button-hover-css text-primary"
                                                onClick={() => downloadPDF(eachRecord, userAllInfo[idx].sampleid, userAllInfo[idx].patientname)}
                                                style={{ marginTop: "18px" }}
                                            >
                                                download pdf <i className="fas fa-download"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <a
                                                style={{ textDecoration: "none" }}
                                                href={`https://silly-mestorf-e2e1f9.netlify.app/?${dsridsArray[idx]}`}
                                                alt="dsr-report"
                                                target={"_blank"}
                                            >
                                                {"View"}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            ))}
                        </Table>

                    </div>
                }
            </div>
        </div>
    )
}

export default DragDropCsv
